var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamondColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1771 7.90919C17.4587 7.5482 17.6164 7.10603 17.6268 6.64831C17.6373 6.19058 17.4998 5.74169 17.2349 5.36825L14.7427 1.8794C14.5469 1.60506 14.2884 1.38144 13.9887 1.22713C13.689 1.07281 13.3569 0.992267 13.0198 0.992188L5.29958 0.992188C4.96252 0.992267 4.63034 1.07281 4.33068 1.22713C4.03101 1.38144 3.77252 1.60506 3.57668 1.8794L1.08444 5.36825C0.820074 5.742 0.683147 6.19098 0.693953 6.64865C0.704759 7.10632 0.862723 7.54834 1.14444 7.90919L9.15969 18.008L17.1771 7.90919ZM5.80918 7.34454L7.78547 14.0018L2.49819 7.34454H5.80918ZM15.8212 7.34454L10.5374 14.0018L12.5102 7.34454H15.8212ZM11.0379 7.34454L9.15969 13.6821L7.28151 7.34454H11.0379ZM7.27234 5.93291L8.28024 2.40382H10.0391L11.047 5.93291H7.27234ZM13.5943 2.69956L15.9038 5.93291H12.5159L11.5072 2.40382H13.0198C13.1322 2.40381 13.243 2.43064 13.3429 2.48208C13.4428 2.53352 13.529 2.60808 13.5943 2.69956ZM4.72505 2.69956C4.79035 2.60808 4.87655 2.53352 4.97648 2.48208C5.07641 2.43064 5.18719 2.40381 5.29958 2.40382H6.81215L5.80424 5.93291H2.41632L4.72505 2.69956Z",
    fill: "url(#paint0_linear_7082_448)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7082_448",
    x1: 0.693359,
    y1: 9.4995,
    x2: 17.6231,
    y2: 9.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA429D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#7D55D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#0073C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondColored);
export default __webpack_public_path__ + "static/media/diamondColored.f705c80c2b5df0425d77655576b013b8.svg";
export { ForwardRef as ReactComponent };